import image from '../../../../icons/USA_Map.svg'
import {styled} from '@mui/material/styles'
import {useConfig} from '../../../../store/hooks/config'
import {useStatesAndHealthConditions, useUpdateDefaultContext} from '../../../../store/hooks/breadCrumbs'
import PropTypes from 'prop-types'
import {Box} from '@mui/material'

const ResetNationView = ({mapRef}) => {
  const map = mapRef // mapRef is already the map instance, not a ref object
  const zoomOutText = 'Reset to Nation view'
  const nationViewMapLongitude = -100
  const nationViewMapLatitude = 40
  const {updateDefaultState} = useUpdateDefaultContext()
  const {statesConfig} = useConfig() || {}
  const {filters} = useStatesAndHealthConditions()
  const filtersCopy = structuredClone(filters)
  const getAllStates = filtersCopy?.find((value) => value.key === 'state')?.values

  // this function updates the default state to entire united state
  const updateToEntireUnitedState = (getAllStates) => {
    if (
      getAllStates &&
      getAllStates.length > 0 &&
      getAllStates[0]?.STATE_NAME === statesConfig?.entireUnitedStateLabel
    ) {
      updateDefaultState([getAllStates[0].STATE_NAME], getAllStates, [])
    }
  }

  // this function is used to reset the view to nation level
  const resetMap = () => {
    if (getAllStates) {
      updateToEntireUnitedState(getAllStates)
    }

    map?.flyTo({
      zoom: 3,
      center: [nationViewMapLongitude, nationViewMapLatitude]
    })
  }
  return (
    <StyledBox>
      <div style={{position: 'absolute', top: '70px', left: '20px'}}>
        <StyledButton className='reset-button' onClick={resetMap} title={zoomOutText}>
          <img src={image} alt={'button'} width='20' height='20' />
        </StyledButton>
      </div>
    </StyledBox>
  )
}
const StyledButton = styled('button')(({theme}) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  cursor: 'pointer',
  width: '32px',
  height: '32px',
  borderRadius: '50%',
  backgroundColor: theme.palette.hpWhite,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px solid ${theme.palette.hpWhite}`,
  boxShadow: theme.shadows[4],
  ':hover': {
    backgroundColor: theme.palette.grey[100]
  }
}))
const StyledBox = styled(Box)(({theme}) => ({
  position: 'absolute',
  padding: '10px',
  zIndex: 2,
  bottom: '92px',
  left: '74px',
  [theme.breakpoints.xl]: {
    left: '0px'
  },
  [theme.breakpoints.up('xl')]: {
    left: '0px'
  },
  [theme.breakpoints.between(1526, 1628)]: {
    left: '74px'
  }
}))

ResetNationView.propTypes = {
  mapRef: PropTypes.object.isRequired
}
export default ResetNationView

/**
 * List of functions and their purpose:
 *
 * - updateToEntireUnitedState: Updates the default state filter to the entire United States.
 * - resetMap: Resets the map view to the national level, clears all SDOH filters, and resets the state selection.
 */
